<template>
  <button
    :class="{
      'probate-quiz-tool-back': true,
    }"
    @click.prevent="handleBack"
  >
    <span class="probate-quiz-tool-back__label">{{ label }}</span>
  </button>
</template>
<script setup lang="ts">
import { useProbateQuizTool } from '~/composables/probate-quiz-tool';

const { back } = useProbateQuizTool();
const label = '< Back';

const props = defineProps({
  onBack: {
    type: Function,
    required: false,
    default: null,
  },
});

const handleBack = () => {
  if (props.onBack) {
    props.onBack();
  } else {
    back();
  }
};
</script>
